import { render, staticRenderFns } from "./UsuariosZona.vue?vue&type=template&id=20da749d"
import script from "./UsuariosZona.vue?vue&type=script&lang=js"
export * from "./UsuariosZona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports